export const formatCspireAssignmentDisplayName = (cspireWorkOrder) => {
  const wo = cspireWorkOrder;
  return `CSpire - ${wo?.locationName || wo?.site?.locationName || wo?.workOrderNumber || 'WO'}`;
};
